import React, { forwardRef, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';

import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { PROJECT_ROLES } from 'constant';
import ViewListProjectProposal from '../ViewListProjectProposal';

const AddProjectProposalDialog = forwardRef(
  ({ curMembers, councilTypeSelected, isVisible, setIsVisible }, ref) => {
    const { t } = useTranslation();
    // const [visible, setVisible] = useState(false);
    const [proposalsControl, setProposalsControl] = useState({});
    const [fields, setFields] = useState([]);

    const onSelectedChange = (selectedItems) => {
      const { append, remove } = proposalsControl;
      selectedItems.forEach((item) => {
        const isExist = fields.some((field) => field?.reference === item?.reference);

        if (!isExist) {
          const owner = item?.projectProposalContacts.find(
            (contact) => contact?.projectRole?.code === PROJECT_ROLES.OWNER
          );
          append({
            vietnameseName: item?.vietnameseName,
            projectType: item?.projectType,
            fullName: owner?.fullname || item?.projectProposalContacts?.[0]?.fullname,
            program: item?.program?.name,
            programId: item?.programId,
            researchFields: item?.projectProposalResearchFields,
            id: item?.id,
            reference: item?.reference,
            organizationId: item?.contact?.organizationId,
            members: item?.projectProposalContacts,
            projectProposalContacts: item?.projectProposalContacts,
            hasCouncilResult: item?.hasCouncilResult,
            hasReview: item?.hasReview,
          });
        }
      });

      const indexesToRemove = [];
      fields.forEach((field, index) => {
        const isNotSelected = !selectedItems.some((item) => item.reference === field.reference);
        if (isNotSelected) {
          indexesToRemove.push(index);
        }
      });

      // Xóa các phần tử từ cuối mảng để tránh việc dịch chuyển vị trí của các phần tử
      for (let i = indexesToRemove.length - 1; i >= 0; i -= 1) {
        remove(indexesToRemove[i]);
      }
    };
    useImperativeHandle(
      ref,
      () => ({
        open: (_proposalsControl) => {
          setProposalsControl(_proposalsControl);
          setFields(_proposalsControl?.fields);
          setIsVisible(true);
        },
      }),
      []
    );
    return (
      <Dialog
        header={
          proposalsControl?.type === 'APPEND'
            ? t('council.createForManyProjectProposal.projectProposalDialog.add')
            : t('council.createForManyProjectProposal.projectProposalDialog.update')
        }
        visible={isVisible}
        onHide={() => setIsVisible(false)}
        draggable={false}
        className="w-full sm:w-9 lg:w-10"
      >
        <ViewListProjectProposal
          onSelectedChange={onSelectedChange}
          projectProposals={fields}
          setVisible={setIsVisible}
          curMembers={curMembers}
          councilTypeSelected={councilTypeSelected}
        />
      </Dialog>
    );
  }
);

AddProjectProposalDialog.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  curMembers: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  councilTypeSelected: PropTypes.object,
  isVisible: PropTypes.bool.isRequired,
  setIsVisible: PropTypes.func.isRequired,
};

AddProjectProposalDialog.defaultProps = {
  curMembers: [],
  councilTypeSelected: {},
};

export default AddProjectProposalDialog;
